import React, { useEffect, useRef, useState } from "react";
import {
  DropdownContainer,
  DropdownIcon,
  DropdownInput,
  DropdownItem,
  DropdownList,
} from "./DropdownWithObjects.styles";
import { DropdownOption, DropdownWithObjectsProps } from "./DropdownWithObjects.types";

const DropdownWithObjects: React.FC<DropdownWithObjectsProps> = ({
  options,
  placeholder = "Выберите значение",
  onChange,
  value = "",
  setBottomOffset,
}) => {
  const [inputValue, setInputValue] = useState<string>(
    options.find((option) => option.value === value)?.label || "",
  );
  const [filteredOptions, setFilteredOptions] = useState<DropdownOption[]>(options);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsDropdownOpen((current) => !current);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = event.target.value;
    setInputValue(userInput);
    setFilteredOptions(
      options.filter((option) => option.label.toLowerCase().includes(userInput.toLowerCase())),
    );
  };

  const handleOptionClick = (option: DropdownOption) => {
    setInputValue(option.label);
    onChange(option.value);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    const selectedOption = options.find((option) => option.value === value);
    setInputValue(selectedOption?.label || "");
  }, [value, options]);

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownInput
        type="text"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        onClick={() => setIsDropdownOpen(true)}
        onFocus={() => setBottomOffset?.(200)}
        onBlur={() => setBottomOffset?.(0)}
        aria-expanded={isDropdownOpen}
      />
      <DropdownIcon $isOpen={isDropdownOpen} onClick={toggleDropdown} aria-hidden="true" />
      {isDropdownOpen && (
        <DropdownList>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <DropdownItem key={option.value} onClick={() => handleOptionClick(option)}>
                {option.label}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem>Нет совпадений</DropdownItem>
          )}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default DropdownWithObjects;
